import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TextField } from '@src/components/TextField';
import { Appearance, Button } from '@src/components/Button';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { closeModal } from '@src/redux/actions/modal';
import { setErrorFlashMessage, setSuccessFlashMessage } from '@src/redux/actions/flashMessages';
import api from '@src/util/api';
import { ERROR_CODES } from '@src/constants';
import { trackEvent } from '@src/metrics';
import './styles.scss';

const InviteTeamModalContent = ({ closeModal, setErrorFlashMessage, setSuccessFlashMessage, onSuccess }) => {
  const [email, setEmail] = useState('');
  const [fullName, setName] = useState('');
  const [loading, setLoading] = useState(false);

  return (
    <div className="invite-team-modal">
      <div className="invite-team-modal__title">Invite people</div>

      <div className="invite-team-modal__text">
        Fill in the details below to send an email with the registration link.
      </div>

      <TextField
        defaultValue={email}
        disabled={loading}
        fullWidth
        label="Email"
        onBlur={() =>
          trackEvent({
            context: MetricContext.INVITING_TEAM_MEMBERS,
            interaction: MetricAction.SET_INVITEE_EMAIL,
          })
        }
        onChange={value => setEmail(value)}
        placeholder="Email address"
        wrapperClassName="invite-team-modal__input"
      />

      <TextField
        defaultValue={fullName}
        disabled={loading}
        fullWidth
        label="Name"
        onBlur={() =>
          trackEvent({
            context: MetricContext.INVITING_TEAM_MEMBERS,
            interaction: MetricAction.SET_INVITEE_NAME,
          })
        }
        onChange={value => setName(value)}
        placeholder="First and last name"
        wrapperClassName="invite-team-modal__input"
      />

      <div className="invite-team-modal__footer">
        <Button
          isDisabled={email.length === 0 || fullName.length === 0 || loading}
          onClick={async () => {
            try {
              setLoading(true);

              await api.post('/api/team/invites', {
                email: email,
                fullName: fullName,
                role: 'recruiter',
              });

              setSuccessFlashMessage('Invite successfully sent');

              onSuccess && (await onSuccess());

              setLoading(false);

              closeModal();
            } catch (e) {
              setLoading(false);

              setErrorFlashMessage(ERROR_CODES[e.body && e.body.key]);
            }

            trackEvent({
              context: MetricContext.INVITING_TEAM_MEMBERS,
              interaction: MetricAction.INVITE_TEAM_MEMBER,
            });
          }}
        >
          Invite
        </Button>

        <Button
          appearance={Appearance.SECONDARY}
          className="invite-team-modal__cancel-button"
          onClick={() => closeModal()}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

InviteTeamModalContent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  setErrorFlashMessage: PropTypes.func.isRequired,
  setSuccessFlashMessage: PropTypes.func.isRequired,
};

export default connect(null, {
  closeModal,
  setErrorFlashMessage,
  setSuccessFlashMessage,
})(InviteTeamModalContent);
